export const MAIN_CONTENT_LOADING = "MAIN_CONTENT_LOADING";
export const MAIN_CONTENT = "MAIN_CONTENT";
export const FETCH_BLOGS_NEWS_LOADING = "FETCH_BLOGS_NEWS_LOADING";
export const FETCH_NEWS = "FETCH_NEWS";
export const FETCH_BLOGS = "FETCH_BLOGS";
